import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { ReactComponent as NewWindowIcon } from '../../assets/img/svg/new-window.svg';
import * as ActionCreators from '../../redux/action';
import dlt from '../../utils/default-lang';
import { getDownloadUrlForDocument } from '../../utils/download';
import IdentityDropzone from '../investor-onboarding-content/identity-form/identity-dropzone';
import { DropdownIndicator } from '../investor-onboarding-content/identity-form/identity-form';
import {
  IdentityFormErrorSC,
  IdentityFormTextInputSC,
} from '../investor-onboarding-content/identity-form/identity-form.styled';
import { BiggerText, BodyText } from '../typography';
import Button from '../ui/button';
import Checkbox from '../ui/checkbox/checkbox';
import PersonalInformationProcessingFormSchema from './personal-information-processing-form-rules';
import PersonalFormSC, { PersonalFormErrorSC } from './personal-information-processing-form.styled';

const id_card_key = 7;
const formInitialValues = {
  information: false,
  transfer: false,
  marketing: false,
  rejected: false,
  termination: false,
  first_identity: id_card_key,
  first_identity_number: '',
  first_identity_image_front: '',
  first_identity_image_back: '',
  second_identity: '',
  second_identity_number: '',
  second_identity_image_front: '',
  second_identity_image_back: '',
};

const PersonalInformationProcessingForm = ({
  onSubmit,
  intl,
  onBoardingDocumentTypes,
  getDebtorDocumentTypes,
  registrationData,
}) => {
  const [firstFile, setFirstFile] = useState({});
  const [firstBackFile, setFirstBackFile] = useState({});
  const [secondFile, setSecondFile] = useState({});
  const [secondBackFile, setSecondBackFile] = useState({});
  const [identityData, setIdentityData] = useState([]);

  useEffect(() => {
    getDebtorDocumentTypes();
  }, [getDebtorDocumentTypes]);

  useEffect(() => {
    setIdentityData(
      onBoardingDocumentTypes.map(({ key, value }) => ({
        value: key,
        label: value,
      }))
    );
  }, [intl, onBoardingDocumentTypes]);

  const allFiles = [firstFile, firstBackFile, secondFile, secondBackFile];

  return (
    <PersonalFormSC>
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={PersonalInformationProcessingFormSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, touched, handleChange, handleSubmit, handleBlur }) => {
          const informationHasError = errors && errors.information && touched.information;
          const firstIdentityHasError = errors && errors.first_identity && touched.first_identity;
          const firstIdentityNumberHasError =
            errors && errors.first_identity_number && touched.first_identity_number;
          const secondIdentityHasError =
            errors && errors.second_identity && touched.second_identity;
          const secondIdentityNumberHasError =
            errors && errors.second_identity_number && touched.second_identity_number;
          const firstIdentityImageFrontHasError =
            errors && errors.first_identity_image_front && touched.first_identity_image_front;
          const secondIdentityImageFrontHasError =
            errors && errors.second_identity_image_front && touched.second_identity_image_front;
          const firstIdentityImageBackHasError =
            errors && errors.first_identity_image_back && touched.first_identity_image_back;
          const secondIdentityImageBackHasError =
            errors && errors.second_identity_image_back && touched.second_identity_image_back;

          return (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="personal_information_processing_document"
                      defaultMessage={dlt['personal_information_processing_document']}
                    />
                    {': '}
                    <a
                      className="document-link"
                      href={
                        registrationData
                          ? getDownloadUrlForDocument(
                              registrationData.data.information_processing_info_doc.url
                            )
                          : ''
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FormattedMessage
                        id="personal_information_processing_info_doc"
                        defaultMessage={dlt['personal_information_processing_info_doc']}
                      />
                      <NewWindowIcon />
                    </a>
                  </BodyText>
                  <div className="separator"></div>
                </div>
                <div className="full-block">
                  <div>
                    <Checkbox
                      name="information"
                      hasError={informationHasError}
                      value={values.information}
                      checked={values.information || false}
                      onChange={handleChange}
                      withInsideContent
                      bold={false}
                    >
                      <FormattedHTMLMessage
                        id="personal_information_processing_agree_information"
                        defaultMessage={dlt['personal_information_processing_agree_information']}
                      />
                    </Checkbox>
                    {informationHasError ? (
                      <PersonalFormErrorSC>{errors.information}</PersonalFormErrorSC>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="personal_information_processing_document"
                      defaultMessage={dlt['personal_information_processing_document']}
                    />
                    {': '}
                    <a
                      className="document-link"
                      href={
                        registrationData
                          ? getDownloadUrlForDocument(
                              registrationData.data.information_processing_agrees_doc.url
                            )
                          : ''
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FormattedMessage
                        id="personal_information_processing_agrees_doc"
                        defaultMessage={dlt['personal_information_processing_agrees_doc']}
                      />
                      <NewWindowIcon />
                    </a>
                  </BodyText>
                  <div className="separator"></div>
                </div>
                <div className="full-block">
                  <Checkbox
                    name="marketing"
                    value={values.marketing}
                    checked={values.marketing || false}
                    onChange={handleChange}
                    withInsideContent
                    bold={false}
                  >
                    <FormattedHTMLMessage
                      id="personal_information_processing_agrees_marketing"
                      defaultMessage={dlt['personal_information_processing_agrees_marketing']}
                    />
                  </Checkbox>
                </div>
                <div className="full-block">
                  <Checkbox
                    name="rejected"
                    value={values.rejected}
                    checked={values.rejected || false}
                    onChange={handleChange}
                    withInsideContent
                    bold={false}
                  >
                    <FormattedHTMLMessage
                      id="personal_information_processing_agrees_rejected"
                      defaultMessage={dlt['personal_information_processing_agrees_rejected']}
                    />
                  </Checkbox>
                </div>
                <div className="full-block">
                  <Checkbox
                    name="termination"
                    value={values.termination}
                    checked={values.termination || false}
                    onChange={handleChange}
                    withInsideContent
                    bold={false}
                  >
                    <FormattedHTMLMessage
                      id="personal_information_processing_agrees_termination"
                      defaultMessage={dlt['personal_information_processing_agrees_termination']}
                    />
                  </Checkbox>
                </div>
              </div>
              <div className="row" style={{ marginTop: '25px' }}>
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="personal_information_processing_document_1"
                      defaultMessage={dlt['personal_information_processing_document_1']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="personal_information_processing_document_type_placeholder"
                    defaultMessage={
                      dlt['personal_information_processing_document_type_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <Select
                        name="first_identity"
                        instanceId={1}
                        isSearchable={false}
                        components={{ DropdownIndicator }}
                        value={
                          identityData.find((op) => op.value === values.first_identity) || null
                        }
                        placeholder={placeholder}
                        classNamePrefix={
                          firstIdentityHasError ? 'react-select-error' : 'react-select'
                        }
                        onBlur={handleBlur}
                        isOptionDisabled={(op) => op.active === false}
                        options={identityData.filter((op) => op.value === id_card_key)}
                        noOptionsMessage={() =>
                          intl.formatMessage({
                            id: 'global_no_results',
                            defaultMessage: dlt['global_no_results'],
                          })
                        }
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: 'first_identity',
                              value: e.value,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {firstIdentityHasError ? (
                    <IdentityFormErrorSC>{errors.first_identity}</IdentityFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="personal_information_processing_document_number_placeholder"
                    defaultMessage={
                      dlt['personal_information_processing_document_number_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <IdentityFormTextInputSC
                        type="text"
                        name="first_identity_number"
                        placeholder={placeholder}
                        filled={values.first_identity_number}
                        hasError={firstIdentityNumberHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.first_identity_number || ''}
                      />
                    )}
                  </FormattedMessage>
                  {firstIdentityNumberHasError ? (
                    <IdentityFormErrorSC>{errors.first_identity_number}</IdentityFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <IdentityDropzone
                    allFiles={allFiles}
                    name="first_identity_image_front"
                    onBlur={handleBlur}
                    hasError={firstIdentityImageFrontHasError}
                    side="front"
                    setSelectedFile={(files) => {
                      setFirstFile(files[0]);
                      handleChange({
                        target: {
                          name: 'first_identity_image_front',
                          value: files[0],
                        },
                      });
                    }}
                  />
                  {firstIdentityImageFrontHasError ? (
                    <IdentityFormErrorSC>{errors.first_identity_image_front}</IdentityFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <IdentityDropzone
                    allFiles={allFiles}
                    name="first_identity_image_back"
                    onBlur={handleBlur}
                    hasError={firstIdentityImageBackHasError}
                    side="back"
                    setSelectedFile={(files) => {
                      setFirstBackFile(files[0]);
                      handleChange({
                        target: {
                          name: 'first_identity_image_back',
                          value: files[0],
                        },
                      });
                    }}
                  />
                  {firstIdentityImageBackHasError ? (
                    <IdentityFormErrorSC>{errors.first_identity_image_back}</IdentityFormErrorSC>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="heading-block">
                  <BodyText className="bolder">
                    <FormattedMessage
                      id="personal_information_processing_document_2"
                      defaultMessage={dlt['personal_information_processing_document_2']}
                    />
                  </BodyText>
                  <div className="separator"></div>
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="personal_information_processing_document_type_placeholder"
                    defaultMessage={
                      dlt['personal_information_processing_document_type_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <Select
                        name="second_identity"
                        instanceId={2}
                        isSearchable={false}
                        components={{ DropdownIndicator }}
                        value={
                          identityData.find((op) => op.value === values.second_identity) || null
                        }
                        placeholder={placeholder}
                        classNamePrefix={
                          secondIdentityHasError ? 'react-select-error' : 'react-select'
                        }
                        onBlur={handleBlur}
                        isOptionDisabled={(op) => op.active === false}
                        options={identityData.filter((op) => op.value !== id_card_key)}
                        noOptionsMessage={() =>
                          intl.formatMessage({
                            id: 'global_no_results',
                            defaultMessage: dlt['global_no_results'],
                          })
                        }
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: 'second_identity',
                              value: e.value,
                            },
                          });
                        }}
                      />
                    )}
                  </FormattedMessage>
                  {secondIdentityHasError ? (
                    <IdentityFormErrorSC>{errors.second_identity}</IdentityFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <FormattedMessage
                    id="personal_information_processing_document_number_placeholder"
                    defaultMessage={
                      dlt['personal_information_processing_document_number_placeholder']
                    }
                  >
                    {(placeholder) => (
                      <IdentityFormTextInputSC
                        type="text"
                        name="second_identity_number"
                        placeholder={placeholder}
                        filled={values.second_identity_number}
                        hasError={secondIdentityNumberHasError}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.second_identity_number || ''}
                      />
                    )}
                  </FormattedMessage>
                  {secondIdentityNumberHasError ? (
                    <IdentityFormErrorSC>{errors.second_identity_number}</IdentityFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <IdentityDropzone
                    allFiles={allFiles}
                    name="second_identity_image_front"
                    onBlur={handleBlur}
                    hasError={secondIdentityImageFrontHasError}
                    side="front"
                    setSelectedFile={(files) => {
                      setSecondFile(files[0]);
                      handleChange({
                        target: {
                          name: 'second_identity_image_front',
                          value: files[0],
                        },
                      });
                    }}
                  />
                  {secondIdentityImageFrontHasError ? (
                    <IdentityFormErrorSC>{errors.second_identity_image_front}</IdentityFormErrorSC>
                  ) : null}
                </div>

                <div className="half-block">
                  <IdentityDropzone
                    allFiles={allFiles}
                    name="second_identity_image_back"
                    onBlur={handleBlur}
                    hasError={secondIdentityImageBackHasError}
                    side="back"
                    setSelectedFile={(files) => {
                      setSecondBackFile(files[0]);
                      handleChange({
                        target: {
                          name: 'second_identity_image_back',
                          value: files[0],
                        },
                      });
                    }}
                  />
                  {secondIdentityImageBackHasError ? (
                    <IdentityFormErrorSC>{errors.second_identity_image_back}</IdentityFormErrorSC>
                  ) : null}
                </div>
              </div>
              <div className="row" style={{ marginTop: '25px' }}>
                <div className="full-block">
                  <BiggerText>
                    <FormattedHTMLMessage
                      id="personal_information_processing_button_hint"
                      defaultMessage={dlt['personal_information_processing_button_hint']}
                    />
                  </BiggerText>
                  <Button type="PRIMARY" className="form-submit" onClick={handleSubmit}>
                    <FormattedMessage
                      id="personal_information_processing_button"
                      defaultMessage={dlt['personal_information_processing_button']}
                    />
                  </Button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </PersonalFormSC>
  );
};

const mapStateToProps = (state) => {
  return {
    onBoardingDocumentTypes: state.onboarding_document_types,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDebtorDocumentTypes: ActionCreators.getDebtorDocumentTypes,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(PersonalInformationProcessingForm));
